import React from "react";
import Slider from "react-slick";
import { Link } from "react-router";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PackagesData from "../../models/PackagesHomeData";
import TitleComponent from "../common/TitleComponent";

const PackagesSlider = () => {
  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear",
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 1,
    // speed: 3000,
    speed: 1000,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
        }
      }
    ]
  };

  const description =
    `Discover the transformative power of our exclusive wellness packages, designed to rejuvenate your body, mind, and spirit.
    Whether you're seeking stress relief, increased energy, or overall relaxation, our personalized treatments offer lasting benefits that promote total well-being.
    Our expert therapists tailor each session to your individual needs, ensuring a truly unique experience that addresses your specific health concerns.
    From boosting circulation to enhancing mental clarity, these treatments help you feel revitalized and balanced.
    Take the time to invest in yourself, relax, and recharge. Treat your body to the care it deserves and experience the positive changes in your health and happiness.`;

  return (
    <>
      <TitleComponent Title={"Our Packages"} Subtitle={description} />

      <div className="py-7">
        <Slider {...settings}>

          {PackagesData.map((item) => (

            <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4" key={item.id}>
              <div className="featured-imagebox featured-imagebox-service style1">
                <div className="featured-thumbnail">
                  <img
                    className="w-full lg:h-72 h-52"
                    src={item.src}
                    alt={item.alt}
                  />
                </div>
                <Link to={`/Treatments`}>
                  <div className="featured-content slick_title">
                    <div className="featured-title ">
                      <h3 className="title_DMSerifText-Regular">
                        {item.title}
                      </h3>
                    </div>
                    <div className="featured-desc">
                      <h3 className="text_AbhayaLibre-Regular text-xl">{item.subtitle}</h3>
                    </div>
                  </div>
                </Link>
              </div>
            </div>

          ))}

        </Slider>
      </div>

    </>
  );
};

export default PackagesSlider;
